import { render, staticRenderFns } from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=template&id=a21ae530&scoped=true"
import script from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=style&index=0&id=a21ae530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21ae530",
  null
  
)

export default component.exports